// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1aQ9X","cardBadge":"styles_cardBadge__2tEeo","icon":"styles_icon__1PmdF","title":"styles_title__1Adi9"};